import React from "react";
import { useTranslation } from "@helpers/translate";

/**
 * @param {object} props
 * @param {string} props.liquidationText
 */
export const LiquidationPrice = ({ liquidationText }) => {
  const { __ } = useTranslation();

  return (
    <p className="trade-form__liq">
      <span className="trade-form__liq-label">{__("futures.liquidation_price")}:</span>
      <span className="trade-form__liq-value">{liquidationText}</span>
    </p>
  );
};
